<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title">Evaluación Solvenza</h4>
        <button type="button" class="close" (click)="cancel()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="form-group row">
            <div class="col-4">
                <app-pos-qr-code [encode]="true" [value]="qrValue"></app-pos-qr-code>
            </div>
            <div class="col-8">
                <h5 [ngClass]="{'bg-success': status.status == 'FINISHED',
                'bg-secondary': status.status == 'PENDING', 
                'bg-warning':status.status =='IN_PROCESS',
                'bg-danger': status.status == 'ERROR'}" class="bg-success">{{status.message}}</h5>
                <button type="button" class="btn btn-primary" (click)="refresh()">Refrescar Estado</button>

            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary" (click)="confirm()"
            [disabled]="status.status != 'FINISHED'">Pre
            Aprobar</button>
        <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancelar</button>
    </div>
</div><!-- /.modal-content -->